<template lang="html">
  <section class="wcc fields section swipe-to-reset" @touchstart="touchStart" @touchmove="touchMove" @touchend="cancel">
    <div class="wcc section-content" :style="{transform: 'translateX(' + translateX + 'px)'}">
      <slot></slot>
    </div>
  </section>
</template>
<script>
  export default {
    props: ['boundData'],
    data() {
      return {
        track: false,
        startX: null,
        translateX: 0,
        originalValue: null
      }
    },
    methods: {
      touchStart($event) {
        if (this.boundData.value != this.originalValue) {
          this.track = true
          this.startX = $event.touches[0].pageX
        }
      },
      touchMove($event) {
        if ($event.touches.length == 1 && this.track) {
          let relativeX = this.startX - $event.touches[0].pageX
          if (relativeX < 0) {
            this.translateX = 0
          } else if (relativeX > 125) {
            // too fast without this because of the transition duration
            setTimeout(() => {
              if (relativeX > 120 && this.track) {
                this.reset()
              }
            }, 750);
          } else {
            this.translateX = -relativeX
          }
        } else {
          this.translateX = null
        }
      },
      cancel() {
        this.track=false
        this.startX = null
        this.translateX = 0
      },
      reset() {
        this.startX = null
        this.track = false
        this.translateX = 0
        this.boundData.value = this.originalValue
      }
    },
    mounted() {
      this.originalValue = this.boundData.value
    }
  }
</script>
<style lang="scss">
  .wcc.fields.section {
    overflow: hidden;
    background-color: white;
    color: $blue-mr;
    &.swipe-to-reset {
      background-color: transparent;
      &:after {
        content: 'Reset';
        box-sizing: border-box;
        background-color: $red;
        color: white;
        position: absolute;
        width: 125px;
        height: 100%;
        display: flex;
        top: 0;
        justify-content: center;
        align-items: center;
        right: 0;
        z-index: -1;
      }
    }
    .wcc.section-content {
      transition: transform .3s ease-out;
      background-color: white;
    }
  }
</style>